import { __require as requireDocumentCreateElement } from './node_modules-core-js-internals-document-create-element.js';

var domTokenListPrototype;
var hasRequiredDomTokenListPrototype;

function requireDomTokenListPrototype () {
	if (hasRequiredDomTokenListPrototype) return domTokenListPrototype;
	hasRequiredDomTokenListPrototype = 1;
	// in old WebKit versions, `element.classList` is not an instance of global `DOMTokenList`
	var documentCreateElement = requireDocumentCreateElement();

	var classList = documentCreateElement('span').classList;
	var DOMTokenListPrototype = classList && classList.constructor && classList.constructor.prototype;

	domTokenListPrototype = DOMTokenListPrototype === Object.prototype ? undefined : DOMTokenListPrototype;
	return domTokenListPrototype;
}

export { requireDomTokenListPrototype as __require };
//# sourceMappingURL=node_modules-core-js-internals-dom-token-list-prototype.js.map
